import firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyDue7vPswzGyDgKFPHshqXdjuS_toFfh2k',
  authDomain: 'uchinoko-c130.firebaseapp.com',
  databaseURL: 'https://uchinoko-c130.firebaseio.com',
  projectId: 'uchinoko-c130',
  storageBucket: 'uchinoko-c130.appspot.com',
  messagingSenderId: '850794290907',
  appId: '1:850794290907:web:1c2b4fc98486e13cd6f6fe',
  measurementId: 'G-Z8TNYED8J8'
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)
firebase.analytics()

// window.firebase = firebase

export default firebase
